<footer class="footer" aria-label="Site footer" role="contentinfo">
	<div class="footer-container">
		<div class="footer-col">
			<a class="menu-logo" href="/" aria-label="Homepage" title="Homepage">
				<img class="footer-logo-img" src="/assets/logos/logo.webp" width="180" height="48" alt="logo" />
			</a>
			<span class="footer-tagline">{{ "tagline" | translate }}</span>
		</div>

		<div class="footer-col">
			<h4 class="footer-title">{{ 'FOOTER_QUICK_ACCESS' | translate }}</h4>
			<nav class="footer-links">
				<a [routerLink]="['/', currentLang]" class="footer-link" routerLinkActive="active"
					title="{{ 'Home' | translate }}">{{ "Home" | translate }}</a>

				<a [routerLink]="['/', currentLang, 'support']" class="footer-link" routerLinkActive="active"
					title="{{ 'Support' | translate }}">{{ "Support" | translate }}</a>

				<a [routerLink]="['/', currentLang, 'terms']" class="footer-link" routerLinkActive="active"
					title="{{ 'Terms' | translate }}">{{ "Terms" | translate }}</a>

				<a [routerLink]="['/', currentLang, 'privacy']" class="footer-link" routerLinkActive="active"
					title="{{ 'Privacy' | translate }}">{{ "Privacy" | translate }}</a>

				<a [routerLink]="['/', currentLang, 'payment-policy']" class="footer-link" routerLinkActive="active"
					title="{{ 'PaymentPolicy' | translate }}">{{ "PaymentPolicy" | translate }}</a>

			</nav>
		</div>
		<div class="footer-col">
			<h4 class="footer-title"> {{ 'FOOTER_CONTACT' | translate }}</h4>
			<div class="footer-social">
				<a href="https://www.facebook.com/" class="footer-social-link" aria-label="Facebook"
					rel="nofollow noopener" target="_blank" title="Facebook">
					<img src="/assets/icons/icon-facebook.svg" alt="Facebook" width="24" height="24" />
				</a>
				<a href="https://www.linkedin.com/" class="footer-social-link" aria-label="LinkedIn"
					rel="nofollow noopener" target="_blank" title="LinkedIn">
					<img src="/assets/icons/icon-linkedin.svg" alt="LinkedIn" width="24" height="24" />
				</a>
				<a href="https://twitter.com/" class="footer-social-link" aria-label="Twitter" rel="nofollow noopener"
					target="_blank" title="Twitter">
					<img src="/assets/icons/icon-twitter.svg" alt="Twitter" width="24" height="24" />
				</a>
				<a href="https://www.instagram.com/" class="footer-social-link" aria-label="Instagram"
					rel="nofollow noopener" target="_blank" title="Instagram">
					<img src="/assets/icons/icon-instagram.svg" alt="Instagram" width="24" height="24" />
				</a>
				<a href="https://www.youtube.com/" class="footer-social-link" aria-label="YouTube"
					rel="nofollow noopener" target="_blank" title="YouTube">
					<img src="/assets/icons/icon-youtube.svg" alt="YouTube" width="24" height="24" />
				</a>

			</div>
		</div>
		<div class="footer-col">
			<h4 class="footer-title">{{ 'FOOTER_PAYMENT_METHODS' | translate }}</h4>
			<div class="footer-payment">
				<img src="assets/logos/visa.avif" alt="Visa">
				<img src="assets/logos/master.avif" alt="Mastercard">
				<img src="assets/logos/moestro.avif" alt="Maestro">
				<img src="assets/logos/jcb.avif" alt="JCB">
				<img src="assets/logos/discover.avif" alt="Discover">
				<img src="assets/logos/dinersclub.avif" alt="Diners Club">
				<img src="assets/logos/amex.avif" alt="American Express">
			</div>
		</div>

	</div>
	<div class="footer-bottom">
		© {{ currentYear }} · {{'FOOTER_RIGHTS' | translate}}
	</div>
</footer>